export default __webpack_public_path__ + "static/media/filter-active.2a67e946.svg";